import { StyledIconDots } from './IconDots.styled';

const IconDots = () => {
  return <StyledIconDots />;
};

export default IconDots;
